<template>
    <div class="smart-box zy-list">
        <div class="smart-top-box">
            <Breadcrumb></Breadcrumb>
            <div class="smart-content-box">
                <h2>一键填报</h2>
                <h4>智能分析，一键生成最适合您的志愿表</h4>
            </div>
        </div>
        <div class="smart-frame-box">
            <div>
                <div class="smart-frame-title"><span></span>一键填报</div>
                <el-form :inline="true" :model="form" ref="form" class="smart-form-inline" :rules="rules" label-position="right" label-width="115px">
                    <el-form-item label="高考省份：" prop="province" class="smart-form-item">
                        <el-input disabled v-model="form.province">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="科目组合：" prop="subject_name">
                        <el-input disabled v-model="form.subject_name">
                        </el-input>
                        <!-- <el-button v-for="(item,key,index) in subject_list" :class="key == active_index ? 'active-batch':''" :key="index" @click="changeSubject(key)">{{ item }}</el-button> -->
                    </el-form-item>
                    <el-form-item label="选择批次：" prop="local_batch_type">
                        <el-select v-model="form.local_batch_type">
                            <el-option v-for="(item, index) in batch_list" :label="item.name" :value="item.local_batch_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="考试分数：" prop="score">
                        <el-input v-model="form.score" placeholder="请输入考试分数">
                            <template slot="append">分</template>
                        </el-input>
                    </el-form-item>
                    <el-button type="primary" @click="planSmartSubmit" class="smart-btn-submit">一键生成志愿表</el-button>
                </el-form>
            </div>
            <div v-if="school_list.length > 0">
                <div class="smart-record-box">
                    <div class="smart-record-title">
                        <p><span class="line"></span>志愿表 
                        <span style="margin-left: 10px;font-size: 12px;padding: 4px;background-color: #ff2929;color: #fff;border-radius: 8px;margin-right:10px;cursor: pointer;" @click.stop="handleSpeekSchool()">解读</span></p>
                        <div class="smart-record-btn" @click="savePlanSmartSubmit">保存</div>
                    </div>
                    <div class="el-collapse">
                        <div>
                            <div name="1" class="collapse-title el-collapse-item">
                                <div>
                                    <el-row class="el-collapse-item__header">
                                        <el-col :span="18">
                                            {{ subject_list[result_form.local_type_id].name}}
                                            <span></span>
                                            {{ result_form.score }}
                                            <span></span>
                                            {{ batch_obj[result_form.local_batch_type].name }}
                                        </el-col>
                                        <el-col :span="6">
                                            录取总概率：
                                            <div>{{ percent }}%</div>
                                        </el-col>
                                    </el-row>
                                    <div style="font-size: 13px;color: #ff933d;margin-top: 10px">{{ lineDesc }}</div>
                                </div>
                                <div class="el-collapse-item__wrap">
                                    <div v-for="(item, index) in school_list" :key="index" class="el-collapse">
                                        <div class="el-collapse-item">
                                            <div>
                                                <el-row class="collapse-box el-collapse-item__header">
                                                    <el-col :span="2">
                                                        <div class="zy-type">{{index + 1}}志愿</div>
                                                    </el-col>
                                                    <el-col :span="2">
                                                        <el-image :src="'https://gaokao.zmpajx.com/pic/'+item.scl_info.scl_id+'.jpg'" alt="大学logo">
                                                            <div slot="error" class="image-slot">
                                                                <img src="../../assets/images/scl_default.png" alt="大学logo">
                                                            </div>
                                                        </el-image>
                                                    </el-col>
                                                    <el-col :span="17">
                                                        <div class="zytb-school-name" style="cursor: pointer;" @click="schoolDetailHandler(item.scl_info.scl_id)">
                                                            {{ item.scl_info.scl_name }}{{ item.scl_info.plan_group? item.scl_info.plan_group : '' }}
                                                            <span style="margin: 0" v-if="item.scl_info.year >= 2024">{{item.scl_info.first_choose }}</span>
                                                            <span style="margin: 0" v-else>首选{{ item.scl_info.first_choose ? subject[item.scl_info.first_choose]:'不限'}},
                                                                <template v-if="item.scl_info.second_choose">再选<template v-for="sub in item.scl_info.second_choose.split('&')">{{subject[sub]}}</template>
                                                                </template>
                                                                <template v-else>
                                                                    再选不限
                                                                </template>
                                                            </span>
                                                        </div>
                                                        <div class="zytb-school-tag">
                                                            <span>{{item.scl_info.province_name}}</span>
                                                            <!-- <template v-if="item.scl_info.scl_nature_type == '6000'">
                                                                <span v-if="item.scl_info.f211 == '1' || item.scl_info.f985 == '1' || item.scl_info.is_provincial == '1' || (item.scl_info.dual_class != '38003' && item.scl_info.dual_class)">
                                                                    本科
                                                                </span>
                                                                <span v-else>
                                                                    普通本科
                                                                </span>
                                                            </template>
                                                            <template v-if="item.scl_info.scl_nature_type == '6001'">
                                                                <span v-if="item.scl_info.is_doublehigh == '77'">
                                                                    专科
                                                                </span>
                                                                <span v-else>
                                                                    普通专科
                                                                </span>
                                                            </template>
                                                            <span v-if="item.scl_nature_type == '6002'">中外合作办学</span> -->
                                                             <span>{{type_edu[item.scl_info.scl_nature_type]}}</span>
                                                            <span>{{ scl_type_list[item.scl_info.scl_type] }}</span>
                                                            <span>{{ scl_nature_list[item.scl_info.scl_nature] }}</span>
                                                            <span v-if="item.scl_info.f211 == '1'" style="background:#fff4e3;color:#fe9f0a;">211</span>
                                                            <span v-if="item.scl_info.f985 == '1'" style="background:#fff0e9;color:$common-color;">985</span>
                                                            <span v-if="item.scl_info.dual_class != '38003' && item.scl_info.dual_class" style="background:#e4f4e9;color:#01c13b;">双一流</span>
                                                            <span v-if="item.scl_info.is_provincial == '1'" style="background: #FDEFFF;color: #D250E0">省重点</span>
                                                            <span v-if="item.scl_info.is_doublehigh == '77'" style="background: #ECEDFF;color: #5964FF">双高计划</span>
                                                        </div>
                                                        <div class="zytb-school-count">
                                                            <div style="line-height: 20px;">
                                                                <span>{{Number(item.scl_info.year) + 1}}招生计划{{item.scl_info.scl_plan_num?item.scl_info.scl_plan_num:'--'}}人</span>
                                                                <span>最低学费{{item.scl_info.min_tuition ? item.scl_info.min_tuition : '--'}}</span>
                                                                <span>{{ item.scl_info.college_code ? '院校代码' + item.scl_info.college_code : '' }}</span>
                                                            </div>
                                                            <div style="line-height: 20px;">
                                                                <span>{{item.scl_info.year}}年最低分{{item.scl_info.score_min?item.scl_info.score_min:'--'}}</span>
                                                                <span>最低位次{{item.scl_info.min_section?item.scl_info.min_section:'--'}}</span>
                                                                <span v-if="section_line && item.scl_info.min_section">比我的位次{{section_line - item.scl_info.min_section >= 0 ? '高' : '低'}}{{Math.abs(section_line - item.scl_info.min_section)}}</span>
                                                                <span v-else>比我的位次-</span>
                                                            </div>
                                                            <div style="line-height: 20px;margin-bottom: 10px;">
                                                                <span>{{Number(item.scl_info.year) - 1}}年最低分{{item.scl_info.sp_min2?item.scl_info.sp_min2:'--'}}</span>
                                                                <span>最低位次{{item.scl_info.sp_min_section2?item.scl_info.sp_min_section2:'--'}}</span>
                                                                <span v-if="section_line && item.scl_info.sp_min_section2">比我的位次{{section_line - item.scl_info.sp_min_section2 >= 0 ? '高' : '低'}}{{Math.abs(section_line - item.scl_info.sp_min_section2)}}</span>
                                                                <span v-else>比我的位次--</span>
                                                            </div>
                                                            <!-- <span>{{item.scl_info.year}}计划{{item.scl_info.stu_num ?item.scl_info.stu_num : '--'}}人</span>
                                                            <span>{{item.scl_info.year}}年最低分{{item.scl_info.score_min ? item.scl_info.score_min : '--'}}</span>
                                                            <span>{{item.scl_info.year}}年最低位次{{item.scl_info.min_section ? item.scl_info.min_section : '--'}}</span> -->
                                                        </div>
                                                    </el-col>
                                                    <el-col :span="3">
                                                        <div class="zytb-school-major">推荐专业({{item.specialty_data.length}})个</div>
                                                        <div class="con-clear"></div>
                                                    </el-col>
                                                </el-row>
                                            </div>
                                            <div class="el-collapse-item__wrap el-collapse-item__content">
                                                <el-row class="collapse-box collapse-box-diff" v-for="(item1,index1) in item.specialty_data" :key="index1">
                                                    <el-col :span="21">
                                                        <el-row class="zytb-school-name">
                                                            <el-col :span="20">
                                                                <div style="cursor: pointer;" @click="clickHandler(item1)">
                                                                    <div>
                                                                        {{item1.spname}}
                                                                    </div>
                                                                    <div class="zytb-school-count">
                                                                        <div style="line-height: 20px;">
                                                                            <span>{{Number(item1.year) + 1}}招生计划{{item1.plan_num?item1.plan_num:'--'}}人</span>
                                                                            <span>学费{{item1.tuition ? item1.tuition : '--'}}</span>
                                                                            <span>{{item1.plan_code ? '专业代码' + item1.plan_code : '' }}</span>
                                                                        </div>
                                                                        <div style="line-height: 20px;">
                                                                            <span>{{item1.year}}招生计划{{item1.sp_num?item1.sp_num:'--'}}人</span>
                                                                            <span>{{item1.year}}年最低分{{item1.sp_min?item1.sp_min:'--'}}</span>
                                                                            <span>最低位次{{item1.sp_min_section?item1.sp_min_section:'--'}}</span>
                                                                            <span v-if="section_line && item1.sp_min_section">比我的位次{{section_line - item1.sp_min_section >= 0 ? '高' : '低'}}{{Math.abs(section_line - item1.sp_min_section)}}</span>
                                                                            <span v-else>比我的位次--</span>
                                                                        </div>
                                                                        <div style="line-height: 20px;">
                                                                            <span>{{Number(item1.year) - 1}}招生计划{{item1.sp_num2?item1.sp_num2:'--'}}人</span>
                                                                            <span>{{Number(item1.year) - 1}}年最低分{{item1.sp_min2?item1.sp_min2:'-'}}</span>
                                                                            <span>最低位次{{item1.sp_min_section2?item1.sp_min_section2:'-'}}</span>
                                                                            <span v-if="section_line && item1.sp_min_section2">比我的位次{{section_line - item1.sp_min_section2 >= 0 ? '高' : '低'}}{{Math.abs(section_line - item1.sp_min_section2)}}</span>
                                                                            <span v-else>比我的位次--</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </el-col>
                                                            <el-col :span="4">
                                                                <span>{{item1.percent}}%
                                                                    <div>录取概率</div>
                                                                </span>
                                                            </el-col>
                                                        </el-row>
                                                    </el-col>
                                                    <div class="con-clear"></div>
                                                </el-row>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
          <!-- 虚拟的学校解说 -->
    <el-dialog
      :title="SpeekTitle"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :visible.sync="SpeekcenterDialogVisible"
      width="80%"
      center
      @close="handleClose"
    >
      <div id="sse_data" style="line-height: 24px"></div>
    </el-dialog>
    </div>
</template>
<script>
import { planSmartSubmit, getPlanCount, getSearchDic } from "@/api/zhiyuan"
import { mapState } from "vuex"
import marked from "marked";
import {
  getToken,
  getApiSign,
  getBaseURLs,
  nowTime,
  getAesCode,
} from "@/utils/auth.js";
export default {

    name: 'smartAspiration',

    data() {
        const validateScore = (rule, value, callback) => {
            if (value.length === 0) {
                callback(new Error("请输入分数"));
            } else {
                if ((/(^[1-9]\d*$)/.test(value)) && value > 0) {
                    callback();
                } else {
                    callback(new Error("请输入正确的分数"));
                }
            }
        };
        return {
            form: {
                local_type_id: '1',
                local_batch_type: '6',
                subject_name: localStorage.getItem('subject_name'),
                score: '',
                province: ''
            },
            SpeekTitle:'',
            SpeekcenterDialogVisible: false,
            aborController: null,
            // showClose: true,
            batch_list: JSON.parse(sessionStorage.getItem('batchList')),
            subject_list: JSON.parse(sessionStorage.getItem('subjectObj')),
            batch_obj: JSON.parse(sessionStorage.getItem('batchObj')),
            options: JSON.parse(sessionStorage.getItem('proInfo')),
            lineDesc: '',
            scl_type_list: {
                5000: '综合',
                5001: '理工',
                5002: '农林',
                5003: '医药',
                5004: '师范',
                5005: '语言',
                5006: '财经',
                5007: '政法',
                5008: '体育',
                5009: '艺术',
                5010: '民族',
                5011: '军事',
                5012: '其他'
            },
            scl_nature_list: {
                36000: '公办',
                36001: '民办'
            },
            section_line: '',
            active_index: 1,
            active_index1: 0,
            rules: {
                local_type_id: [{
                    required: true,
                    trigger: 'blur'
                }],
                subject_name: [{
                    required: true, trigger: 'blur'
                }],
                local_batch_type: [{
                    required: true
                }],
                score: [{
                    required: true,
                    validator: validateScore,
                    trigger: 'blur'
                }]
            },
            school_list: [],
            percent: 0,
            savePlanObj: {},
            subject: {
                wl: '物理',
                hx: '化学',
                zz: '政治',
                sw: '生物',
                dl: '地理',
                ls: '历史'
            },
            // savePlanAreaObj: {
            //     '41': {
            //         6: {
            //             local_batch_type: '本科提前批',
            //             local_batch_id: '6',
            //             scl_count: 5,
            //             major_count: 12,
            //             plan_data: []
            //         },
            //         7: {
            //             local_batch_type: '本科一批',
            //             local_batch_id: '7',
            //             scl_count:12,
            //             major_count: 5,
            //             plan_data: []
            //         },
            //         8: {
            //             local_batch_type: '本科二批',
            //             local_batch_id: '8',
            //             scl_count: 12,
            //             major_count: 5,
            //             plan_data: []
            //         },
            //         11: {
            //             local_batch_type: '专科提前批',
            //             local_batch_id: '11',
            //             scl_count: 5,
            //             major_count: 12,
            //             plan_data: []
            //         },
            //         10: {
            //             local_batch_type: '专科批',
            //             local_batch_id: '10',
            //             scl_count: 12,
            //             major_count: 5,
            //             plan_data: []
            //         }
            //     },
            //     '51': {
            //         6: {
            //             local_batch_type: '本科提前批',
            //             local_batch_id: '6',
            //             scl_count: 2,
            //             major_count: 3,
            //             plan_data: []
            //         },
            //         7: {
            //             local_batch_type: '本科一批',
            //             local_batch_id: '7',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         8: {
            //             local_batch_type: '本科二批',
            //             local_batch_id: '8',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         11: {
            //             local_batch_type: '专科提前批',
            //             local_batch_id: '11',
            //             scl_count: 3,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         10: {
            //             local_batch_type: '专科批',
            //             local_batch_id: '10',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         }
            //     },
            //     '61': {
            //         6: {
            //             local_batch_type: '本科提前批',
            //             local_batch_id: '6',
            //             scl_count: 3,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         7: {
            //             local_batch_type: '本科一批',
            //             local_batch_id: '7',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         8: {
            //             local_batch_type: '本科二批',
            //             local_batch_id: '8',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         11: {
            //             local_batch_type: '专科提前批',
            //             local_batch_id: '11',
            //             scl_count: 3,
            //             major_count: 6,
            //             plan_data: []
            //         },
            //         10: {
            //             local_batch_type: '专科批',
            //             local_batch_id: '10',
            //             scl_count: 9,
            //             major_count: 6,
            //             plan_data: []
            //         }
            //     },
            //     '13': {
            //         6: {
            //             local_batch_type: '本科提前批',
            //             local_batch_id: '6',
            //             scl_count: 96,
            //             major_count: 1,
            //             plan_data: []
            //         },
            //         10: {
            //             local_batch_type: '专科批',
            //             local_batch_id: '10',
            //             scl_count: 96,
            //             major_count: 1,
            //             plan_data: []
            //         },
            //         14: {
            //             local_batch_type: '本科批',
            //             local_batch_id: '14',
            //             scl_count: 96,
            //             major_count: 1,
            //             plan_data: []
            //         }
            //     }
            // },
            area: localStorage.getItem("area"),
            result_form: {},
            has_code: 0,
            type_edu: {}
        }
    },
    computed: {
        ...mapState({
            function_code: state => state.user.function_code
        }),
    },
    watch: {
        function_code() {
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00011'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
        }
    },
    mounted() {
        this.getSearchDicHandler()
        this.getPlanCountHandler()
        this.form.province = this.options.filter(val => { return val.area === this.area})[0].name;
        this.form.local_type_id = localStorage.getItem('localTypeId')
        this.active_index = Object.keys(this.subject_list)[0]
        this.form.local_batch_type = this.batch_list[0].local_batch_id
        const tmp = this.function_code.filter(item => { return item.function_code === 'F00011'})
        if(tmp.length > 0) {
            this.has_code = tmp[0].has_code
        }
        
    },
    methods: {
        getSearchDicHandler() {
            try {
                getSearchDic().then(res => {
                    if (res.status != 200 || !res) {
                        return
                    }
                    res.data.edu_type.map( item => {
                        this.type_edu[item.dic_code] = item.dic_value
                    })
                }).catch(error => {
                    console.log(error);
                })
            } catch (error) { console.log(error) }
        },
        getPlanCountHandler() {
            getPlanCount().then(res => {
               res.data.map(item => {
                    item.plan_data = []
                    this.savePlanObj[item.local_batch_id] = item
                })
                for (const key in this.batch_obj) {
                    if (Object.hasOwnProperty.call(this.batch_obj, key)) {
                        const element = this.batch_obj[key];
                        for(let i = 1; i <= this.savePlanObj[key].scl_count; i++) {
                            let title_tmp = i
                            const obj = {
                                plan_type: `${title_tmp}志愿`,
                                plan_scl: {},
                                specialty_data: []
                            }
                            this.savePlanObj[key].plan_data.push(obj)
                        }
                    }
                }
            })
        },
        planSmartSubmit() {
            if(this.has_code == 0) {
                this.$message({
                    message: '您的账户暂未开通此功能',
                    type: 'warning'
                })
                return
            }
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let count = 0
                    let percent = 0
                    planSmartSubmit(this.form).then(res => {
                        this.school_list = res.data.scl_list
                        this.lineDesc = res.data.tip
                        this.section_line = res.data.section_line
                        res.data.scl_list.map(item => {
                            count += item.specialty_data.length
                            item.specialty_data.map(item1 => {
                                percent += item1.percent
                            })
                        })
                        this.percent = (percent / count).toFixed(0)
                        this.result_form = { ...this.form }
                    })
                }
            })

        },
        changeSubject(index) {
            this.active_index = index
            this.form.local_type_id = index
        },
        changeScore(index) {
            this.active_index1 = index
        },
        savePlanSmartSubmit() {
            this.$store.commit("user/SHOWSAVEPLAN", true);
            let plan = this.savePlanObj[this.form.local_batch_type];
            const savePlanInfor = {}
            this.school_list.map((item, index) => {
                plan.batch_show = false;
                plan.is_plan = true;
                plan.plan_scl = item.scl_info;
                plan.plan_data[index].plan_scl = item.scl_info;
                plan.plan_data[index].specialty_data = item.specialty_data;
            })
            savePlanInfor.avg_percent = this.percent
            let tmp = {}
            const plan_base_info = {
                subject_type: this.subject_list[this.form.local_type_id].name,
                exam_name: '',
                exam_score: this.form.score,
                score_adjust: 0
            }
            tmp = {
                plan_type: '2',
                plan_desc: plan_base_info.subject_type + '/' + this.form.score,
                plan_base_info: plan_base_info
            }
            Object.assign(tmp, this.form)
            Object.assign(savePlanInfor, tmp)
            savePlanInfor.json_str = this.savePlanObj
            this.$store.commit("user/EDITSAVEPLANINFOR", savePlanInfor);
        },
        schoolDetailHandler(scl_id) {
            const { href } = this.$router.resolve({
                name:'school-detail',
                query: {
                    scl_id: scl_id
                }
            })
            window.open(href, '_blank')
        },
        clickHandler(item) {
            if(!item.special_id) {
                this.$message({
                    message: '暂无相关专业信息',
                    type: 'warning'
                })
                return
            }
            this.$router.push({
                path: '/majorDetail',
                query: {
                    special_id: item.special_id
                }
            })
        },
        handleSpeekSchool(){
            // console.log(item)
            let that = this
            this.SpeekTitle = ''
            const sseElement = document.getElementById("sse_data");
            if (sseElement) {
        sseElement.innerHTML = "";
      }
            let area = localStorage.getItem('area')
            let local_type_id = localStorage.getItem('localTypeId')
            let param = {
                area:area,
                score: this.form.score,
                local_type_id:local_type_id,
                plan_info:JSON.stringify(this.savePlanObj)
            }
            let encrypted_data_obj = JSON.parse(
        localStorage.getItem("encrypted_data")
      );
      encrypted_data_obj.timestamp = nowTime();
      let encrypted_data = getAesCode(encrypted_data_obj);
      param.token = getToken();
      param.client_id = "74450c23fa139888c2240568a276879d";
      param.encrypted_data = encrypted_data;
      param.sign = getApiSign(param);
    //   console.log(this.savePlanObj,'this.savePlanObj[this.form.local_batch_type]')
      let ret = "";
      for (const it in param) {
        ret +=
          encodeURIComponent(it) + "=" + encodeURIComponent(param[it]) + "&";
      }
      ret = ret.substr(0, ret.length - 1);
      var url = getBaseURLs() + "api/ai/explain_smart_plan?" + ret;
      let sse_data = "";
      this.SpeekcenterDialogVisible = true;
      fallbackToFetch();
      async function fallbackToFetch() {
        if (that.aborController) {
          that.aborController.abort();
          that.aborController = null;
        }
        let reader = null;
        let sse_data = "";
        try {
          that.aborController = new AbortController();
          const { signal } = that.aborController;
          if (signal.aborted) {
            console.log("请求已被中止，无法发起新请求");
            return;
          }
          const response = await fetch(url, {
            signal: signal,
          });
          if (!response.ok) {
            throw new Error(`HTTP错误: ${response.status}`);
          }
          reader = response.body.getReader();
          while (true) {
            if (signal.aborted) {
              throw new Error("请求已被用户中断");
            }
            const { done, value } = await reader.read();
            // this.showClose = done;
            if (done) break;
            const decodedValue = new TextDecoder().decode(value);
            if (decodedValue.indexOf("DONE") === -1) {
              sse_data += decodedValue;
            }

            if (decodedValue.indexOf("message") !== -1) {
              try {
                sse_data = JSON.parse(decodedValue).message;
              } catch (jsonError) {
                console.error("JSON解析失败:", jsonError);
              }
            }
            const sseElement = document.getElementById("sse_data");
            if (sseElement) {
              sseElement.innerHTML = marked(sse_data);
              document.querySelectorAll("hr").forEach((hr) => {
                hr.style.marginTop = "16px";
                hr.style.marginBottom = "16px";
              });
            }
          }
        } catch (error) {
          if (
            error.name === "AbortError" ||
            error.message === "请求已被用户中断"
          ) {
            console.log("用户已中断请求");
          } else if (error.message.startsWith("HTTP错误")) {
            console.error("请求失败:", error.message);
          } else {
            console.error("处理流时发生错误:", error);
          }
        } finally {
          if (reader) {
            try {
              reader.releaseLock();
            } catch (e) {
              console.log("释放流锁时出错:", e);
            }
          }
        }
      }
            // console.log(item)
        },
        handleClose() {
      if (this.aborController) {
        this.aborController.abort();
        this.aborController = null;
      }
    }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.smart-box {
    .smart-top-box {
        background: url('../../assets/images/smart_bg.png') no-repeat;
        height: 460px;
        background-position: center;
        background-size: cover;

        .smart-content-box {
            @include gwidth;

            h2 {
                font-size: 40px;
                font-weight: 700;
                color: #30343d;
                line-height: 56px;
                letter-spacing: 2px;
                margin-bottom: 0;
                margin-top: 56px;
            }

            h4 {
                font-size: 18px;
                font-weight: 400;
                text-align: left;
                color: #616874;
                line-height: 28px;
                margin-top: 16px;
            }
        }
    }

    .smart-frame-box {
        background: #ffffff;
        border-radius: 10px;
        backdrop-filter: blur(7px);
        @include gwidth;
        margin-top: -184px;
        padding: 24px;
        box-sizing: border-box;

        .smart-frame-title {
            font-size: 20px;
            font-weight: 600;
            color: #2c2e33;
            line-height: 28px;
            margin-bottom: 12px;

            span {
                display: inline-block;
                width: 3px;
                height: 20px;
                background: #ff6524;
                position: relative;
                top: 2px;
                margin-right: 10px;
            }
        }

        ::v-deep .smart-form-inline {
            background: #f7faff;
            border: 1px solid #e1e4eb;
            border-radius: 10px;
            padding: 24px 32px 32px 40px;

            .el-form-item {
                width: 50%;
                margin-right: 0;
            }

            .smart-form-item {
                .el-form-item__error {
                    margin-left: 180px;
                }
            }

            .el-form-item__label {
                font-size: 16px;
                color: #2c2e33;
                line-height: 52px;
                padding: 0;
            }

            .el-input {
                background: #ffffff;
                border: 1px solid #e1e4eb !important;
                border-radius: 8px;
                width: 397px;
                box-sizing: border-box;
            }

            .el-input__inner {
                border: none !important;
                height: 52px !important;
                line-height: 52px;
                border-radius: 8px;
                padding-right: 30px;
            }

            .el-input.is-disabled .el-input__inner {
                color: #332e2c !important;
            }

            .el-input__suffix {
                right: 10px;
            }

            .el-button+.el-button {
                margin-left: 16px;
            }

            .el-button,
            button {
                width: 108px;
                height: 52px;
                background: #ffffff !important;
                border: 1px solid #e1e4eb !important;
                border-radius: 8px;
                color: #5e6166 !important;
                font-size: 16px;
                text-align: center;
                padding: 0;
            }

            .active-batch {
                background: #fff6f3 !important;
                border: 1px solid $common-color !important;
                color: $common-color !important;
            }

            .el-input-group__append {
                padding: 0 !important;
                font-size: 16px;
                font-weight: 400;
                color: #5e6166;
                background: #fff;
                border: none !important;
                border-radius: 8px;
                position: relative;
                right: 16px;
            }

            .smart-btn-diff {
                width: 72px !important;
            }

            .smart-input-diff {
                width: 221px !important;
                margin-left: 16px;
            }

            .smart-btn-submit {
                width: 240px !important;
                height: 50px !important;
                background: linear-gradient(90deg, #ffa94a, #ff913c) !important;
                border-radius: 8px;
                border: none !important;
                text-align: center;
                font-size: 18px;
                color: #ffffff !important;
                position: relative;
                left: 50%;
                transform: translateX(-50%);
                margin-top: 10px;
            }
        }

        .smart-record-box {
            .smart-record-title {
                font-size: 20px;
                color: #332e2c;
                font-weight: 600;
                line-height: 25px;
                margin: 32px 0 24px 0;
                position: relative;

                .line {
                    display: inline-block;
                    width: 3px;
                    height: 20px;
                    background: #ff6524;
                    position: relative;
                    top: 2px;
                    margin-right: 10px;
                }
            }

            .smart-record-btn {
                position: absolute;
                right: 0;
                width: 76px;
                height: 44px;
                background: linear-gradient(90deg, #ffa94a, #ff913c);
                border-radius: 8px;
                font-size: 16px;
                color: #ffffff;
                line-height: 44px;
                text-align: center;
                top: -10px;
                cursor: pointer;
            }
        }
    }
}

.collapse-box {
    width: 100%;
    font-size: 0;

    .el-image,
    img {
        width: 64px;
        height: 64px;
    }

    .zy-type {
        width: 54px;
        height: 30px;
        border: 1px solid $common-color;
        border-radius: 5px;
        font-size: 14px;
        color: $common-color;
        text-align: center;
        line-height: 30px;
        margin-top: -10px;
    }

    .el-col-2 {
        width: 7%;
    }

    .el-col-3 {
        width: 11%;
    }

    .el-col-4 {
        float: right;
    }

    .zytb-school-name {
        font-size: 18px;
        font-weight: 600;
        color: #2c2e33;
        margin-bottom: 5px;
    }

    .zytb-school-tag span {
        display: inline-block;
        padding: 3px 8px;
        font-size: 12px;
        color: #909399;
        height: 22px;
        background: #f0f2f5;
        border-radius: 4px;
        line-height: 22px;
        margin-right: 4px;
    }

    .zytb-school-count span {
        font-size: 12px;
        color: #909399;
        margin-right: 12px;
    }

    .zytb-school-major {
        color: $common-color;
        font-size: 14px;
        margin-top: -15px;
        position: relative;
        right: -45px;
        text-align: right;
    }

    // .el-collapse-item__header {
    //     .el-col-6 {
    //         text-align: right;
    //         font-size: 12px;
    //         color: #999390;
    //         line-height: 17px;
    //     }
    // }
}
.zy-list .el-collapse-item__header {
        line-height: 25px;
        font-weight: 400;
        position: relative;
        .el-col-6 {
            text-align: right;
            font-size: 12px;
            color: #999390;
            line-height: 17px;
            div {
                float: right;
                font-size: 20px;
                font-weight: 600;
                color: $common-color;
            }
        }
    }
.collapse-box-diff {
    @include gflex;
    justify-content: flex-end;

    .zytb-school-name .el-col-4 {
        text-align: right;

        >span {
            display: inline-block;
            padding: 3px 8px;
            font-size: 16px;
            color: #ff6524;
            background: #f0f2f5;
            border-radius: 4px;
            line-height: 22px;
            margin-left: 4px;
            margin-top: 10px;
            text-align: center;

            span {
                font-size: 12px;
            }

            div {
                font-size: 12px;
                color: #999390;
                margin-top: -5px;
            }
        }
    }

    .el-col-21 {
        width: 86%;
    }

    button {
        width: 86px;
        height: 30px;
        line-height: 26px;
        border: 1px solid $common-color;
        border-radius: 5px;
        color: $common-color;
        text-align: center;
        background-color: #fff;
        font-size: 14px;
        float: right;
        margin-top: 10px;
        position: relative;

        img {
            width: 14px;
            height: 14px;
            top: -2px;
            left: 13px;
            position: absolute;
        }
    }

    .zytb-school-btn {
        background: $common-color;
        color: #fff;
        text-align: right;
        padding-right: 8px;
    }
}

.collapse-box-diff:not(:last-child) {
    margin-bottom: 16px;
}
</style>